export const OTHER_ETHNICITY_CODE = '2135-2';

export const ETHNICITY_LIST = [
    {
        'label': 'ssap.input.label.cuban',
        'code': '2182-4',
        'otherLabel': null
    },
    {
        'label': 'ssap.input.label.mexican',
        'code': '2148-5',
        'otherLabel': null
    },
    {
        'label': 'ssap.input.label.puerto_rican',
        'code': '2180-8',
        'otherLabel': null
    },
    {
        'label': '',
        'code': OTHER_ETHNICITY_CODE,
        'otherLabel': null
    }
];